import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Text
} from "recharts";


const CustomXAxisTick = ({ x, y, payload }: any) => {
  if (payload && payload.value) {
    return (
      <Text
          fontSize={"15px"}
          width={"12px"}
          x={x} 
          y={y} 
          textAnchor="middle" 
          verticalAnchor="start"
      >{payload.value}</Text>
    );
  }
  return null;
};

export default function StackedBarChart(props:StackedBarChartData) {
  return (
    <BarChart
      width={900}
      height={500}
      data={props.data}
      margin={{
        top: 20,
        right: 20,
        left: 20,
        bottom: 50,
      }}
      barSize={20}
    >
      <CartesianGrid  horizontal={true} vertical={false} stroke="#ccc" />
      <XAxis dataKey="name" interval={0} tick={<CustomXAxisTick/>} />
      <YAxis axisLine={false} tick={{fontSize: 20}} dx={-10} />
      <Tooltip />
      <Legend
        payload={[
          { id: "Answered", value: "Answered", type: "circle", color: "#99B5F4" },
          { id: "Missed", value: "Missed", type: "circle", color: "#2642A6" }   
        ]}
        width={250}
        wrapperStyle={{
          top: -30,
          right: 20,
          backgroundColor: "white",
          lineHeight: "40px",
        }}
      />
      <Bar dataKey="Missed" stackId="a" fill="#2642A6" />
      <Bar dataKey="Answered" stackId="a" fill="#99B5F4" />
    </BarChart>
  );
}

interface StackedBarChartData{
  data: any[] | undefined;
}
